module.exports = __webpack_public_path__ + "img/aaaa.d41d8cd9.svg";